import React, { ReactElement } from 'react';
import { InvitationForm } from '../../features/auth/InvitationForm';

interface ContentProps {
  invitationToken?: string;
  email?: string;
}

function Content({ invitationToken, email }: ContentProps): ReactElement {
  return <InvitationForm invitationToken={invitationToken} email={email} />;
}

export { Content };
